module.exports = __webpack_public_path__ + "static/media/Capacity-management.c8f4f49a.svg";